"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const loadCSS = (urls, callback) => {
  let loadedCount = 0;
  const total = urls.length;
  if (total === 0) {
    callback();
    return;
  }
  urls.forEach(url => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.onload = function () {
      loadedCount += 1;
      if (loadedCount === total) {
        callback();
      }
    };
    document.head.appendChild(link);
  });
};
const loadJS = (urls, callback) => {
  let loadedCount = 0;
  const total = urls.length;
  if (total === 0) {
    callback();
    return;
  }
  urls.forEach(url => {
    const script = document.createElement('script');
    script.src = url;
    script.onload = () => {
      loadedCount += 1;
      if (loadedCount === total) {
        callback();
      }
    };
    document.body.appendChild(script);
  });
};

// const injectAfterElement = (elementId, scripts, callback) => {
//   const element = document.getElementById(elementId);
//   if (!element) {
//     console.error(`Element #${elementId} not found`);
//     return;
//   }

//   const fragment = document.createDocumentFragment();
//   let loadedCount = 0;
//   const total = scripts.length;
//   scripts.forEach((src) => {
//     const script = document.createElement('script');
//     script.src = src;
//     script.async = true;
//     script.onload = () => {
//       loadedCount += 1;
//       if (loadedCount === total) {
//         callback();
//       }
//     };
//     fragment.appendChild(script);
//   });
//   element?.insertBefore(fragment, element.nextSibling);
// };

function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  if (Object.keys(data).length > 1) {
    const _React$useState = React.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      cssLoaded = _React$useState2[0],
      setCssLoaded = _React$useState2[1];
    // const [jsLoaded, setJsLoaded] = React.useState(false);
    const _ref = data,
      _ref$html = _ref.html,
      html = _ref$html === void 0 ? '' : _ref$html,
      _ref$jsList = _ref.jsList,
      jsList = _ref$jsList === void 0 ? [] : _ref$jsList,
      _ref$cssList = _ref.cssList,
      cssList = _ref$cssList === void 0 ? [] : _ref$cssList,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color;
    // const bgStyle = color ? doComponentsBgColorEvent(color) : {}; // 处理组件背景色
    const jsListScript = jsList.map((item, index) => item.name);
    const cssListScript = cssList.map((item, index) => item.name);
    console.log(cssListScript);
    React.useEffect(() => {
      loadCSS(cssListScript, () => {
        console.log('所有css加载成功');
        setCssLoaded(true);
      });
      loadJS(jsListScript, () => {
        console.log('所有脚本加载成功');
      });

      // 清理函数
      return () => {
        // 移除 CSS
        cssListScript.forEach(url => {
          const link = document.querySelector(`link[href="${url}"]`);
          if (link) {
            document.head.removeChild(link);
          }
        });

        // 移除 JS
        jsListScript.forEach(url => {
          const script = document.querySelector(`script[src="${url}"]`);
          if (script) {
            document.body.removeChild(script);
          }
        });
      };
    }, [html, jsList.length, cssList.length]);
    return /*#__PURE__*/React.createElement("div", Object.assign({
      style: {
        visibility: cssLoaded ? 'visible' : 'hidden',
        height: cssLoaded ? 'auto' : 0,
        overflow: 'hidden'
      },
      id: "customHtml"
    }, (0, _reportUtil.reportShow)(['show_customComponent', componentKey, 'customHtml']), {
      dangerouslySetInnerHTML: {
        __html: html
      }
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}